import styled from "@emotion/styled";

export const TruckSubheaderWrapper = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	h5: {
		margin: 0,
		color: theme.project.colors.primaryColors.main
	},
	"> div": {
		display: "flex",
		gap: "16px"
	},
	"& .MuiAutocomplete-root": {
		width: "341px"
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		alignItems: "flex-start",
		"> div": {
			flexDirection: "column",
			width: "100%",
			marginTop: "16px"
		},
		"& .MuiAutocomplete-root": {
			width: "100%"
		}
	}
}));
